import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { CustomElement, Colors, GeneralCardSubElements } from "@/types";
import { Enrollment } from "@/types";
import { getBreakpoint, isSmaller } from "@/utils";
import { IonCard, IonCardContent, IonGrid, IonRow, IonCol } from "@ionic/vue";
import {
  computed,
  ComputedRef,
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseCard',
  props: {
  credits: {
    type: Number,
    required: true,
  },
  content: {
    type: Array as PropType<CustomElement[]>,
    required: true,
  },
  enrollment: {
    type: Object as PropType<Enrollment>,
    required: true,
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
},
  emits: ["execute_link", "signal_event"],
  setup(__props) {

const props = __props;

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};



const button = props.enrollment.editable && props.content.length > 3;
const actual_content: ComputedRef<CustomElement[]> = computed(() =>
  JSON.parse(JSON.stringify(props.content))
);
const breakpoint = ref(getBreakpoint(window.innerWidth));

if (actual_content.value[0].classes == undefined) {
  actual_content.value[0].classes = {};
}
actual_content.value[0].classes.label = {
  "ion-padding": true,
  radius: true,
};
if (actual_content.value[2].classes == undefined) {
  actual_content.value[2].classes = {};
}
actual_content.value[2].classes.label = {
  "ion-padding": true,
  half_radius: true,
};

onMounted(() =>
  nextTick(() => {
    window.addEventListener("resize", updateBreakpoint);
  })
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateBreakpoint);
});

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createBlock(_unref(IonCard), {
    style: {"width":"100%"},
    class: _normalizeClass([{
      no_card_border: __props.colors?.borders == undefined,
    }, "ion-no-padding ion-no-margin"])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardContent), { class: "ion-no-padding ion-padding-vertical" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), {
                    "size-sm": "auto",
                    size: "6",
                    class: "ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: _unref(actual_content)[0]
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), {
                    size: _unref(isSmaller)(breakpoint.value, 'sm') ? '6' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: __props.content[1],
                        onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('signal_event')))
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }, 8, ["size"]),
                  _createVNode(_unref(IonCol), {
                    "size-sm": "auto",
                    size: "6",
                    class: "ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: _unref(actual_content)[2]
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }),
                  (_unref(button))
                    ? (_openBlock(), _createBlock(_unref(IonCol), {
                        key: 0,
                        size: "auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ionic_element, {
                            element: __props.content[3],
                            onExecute_link: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('execute_link')))
                          }, null, 8, ["element"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})